import React from "react";
import Map, {
  Marker,
  Popup,
  DrawingTools,
  MapConstant,
  Direction,
  MapControls,
} from "../../../../../lib/Map";
import {
  getDispatchLastStop,
  getDispatchWayPoints,
  getDispatchRouteStopsMarker,
  getDispatchDriverMarker,
  getDispatchUnassignedPickupMarker,
} from "../../../../mapComponents/mapHelper";
import {
  DispatchStopPickupPopupInfo,
  DispatchStopDeliveryPopupInfo,
  DispatchUnassignedPickupPopupInfo,
} from "../../../../mapComponents/Popups";
import { withTheme } from "@material-ui/core";
import { compose } from "recompose";
import { observer, inject } from "mobx-react";
import { TerminalMarker } from "../../../../mapComponents/Markers";
import Events from "../../../../../utilities/EventEmitter";
import appConstants from "../../../../../appConstants";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import {
  isDriverDelayed,
  isDelayStop,
  getStopMarkerColors,
  getMarkerComponent,
  getUnassignMarkerInfo,
} from "../../../../modules/Dispatch/RouteExecution/DriverMap/utils";
import { withAppConfig } from "../../../../../appConfigContext";
import { getSpecialNeeds } from "../../../../modules/utils";
import MapZoomChange from "../../../../../lib/Map/Trimble/components/MapZoomChange";
import { getRouteData, getVirtualStopMarker } from "./utils";
import MapHeader from "./components/MapHeader";

@inject("DispatchStore")
@observer
class RouteMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      routeAnimation: true,
      selectedStop: null,
      isAutoZoomEnabled: true,
      selectedPickups: [],
      selectedPickup: null,
    };
  }
  componentDidMount() {
    this.props.glEventHub.on("routeAnimation", this.routeAnimation);
    Events.on("routeAnimationPopup", this.toggleRouteAnimation);
  }
  componentWillUnmount() {
    this.props.glEventHub.off("routeAnimation", this.routeAnimation);
    Events.off("routeAnimationPopup", this.toggleRouteAnimation);
  }

  routeAnimation = (routeAnimation) => {
    this.setState({
      routeAnimation,
    });
  };

  toggleRouteAnimation = (value) => {
    this.setState({
      isAutoZoomEnabled: value,
    });
  };

  onRouteStopClicked = (stop) => {
    this.stopSelectedOnMap = true;
    this.setState({
      selectedStop: stop,
    });
  };

  onMapClicked = () => {
    this.stopSelectedOnMap = false;
    this.pickupSelectedOnMap = false;
    if (this.state.selectedStop || this.state.selectedPickup) {
      this.setState({
        selectedStop: null,
        selectedPickup: null,
      });
    }
  };

  onPickupMarkerClicked = (selectedPickup) => {
    const isActivePickup = this.props.selectedUnassignPickupId.includes(
      selectedPickup.data.pickupId
    );
    if (isActivePickup) {
      this.pickupSelectedOnMap = false;
      this.setState({selectedPickup: null})
      this.props.onUnassignPickupDeselection(selectedPickup.data.pickupId);
    } else {
      this.pickupSelectedOnMap = true;
      this.setState({selectedPickup});
      this.props.onUnassignPickupSelection(selectedPickup.data);
    }
  };

  getPickupActiveStatus = (pickup) => {
    const isPickupSelectedOnMap =
      pickup.pickupId.toLowerCase() ===
      this.state.selectedPickup?.data?.pickupId?.toLowerCase();
    const isPickupSelectedInGrid = this.props.selectedUnassignPickupId.includes(
      pickup.pickupId
    );
    const isPickupActive = isPickupSelectedOnMap || isPickupSelectedInGrid;
    return { isPickupActive, isPickupSelectedInGrid };
  };

  render() {
    const {
      theme,
      classes,
      selectedRoutes,
      noFeasibleDriverPickups,
      DispatchStore,
      userData,
      glEventHub,
    } = this.props;
    const { selectedStop, isAutoZoomEnabled, selectedPickup } = this.state;
    let [isDeliveryStop, isPickupStop] = [false, false];
    let stopPopupCommonProps = {},
      routesData,
      specialNeeds;
    const { offset, location } = userData.userProfile.terminal;
    if (selectedStop) {
      routesData = getRouteData(selectedRoutes, selectedStop.data.driverId);
    }

    if (this.stopSelectedOnMap) {
      specialNeeds = getSpecialNeeds(DispatchStore.priorityAllShipmentList);
      isDeliveryStop =
        selectedStop.data.stopType === appConstants.STOP_TYPE.Delivery;
      isPickupStop =
        selectedStop.data.stopType === appConstants.STOP_TYPE.Pickup;
      stopPopupCommonProps = {
        glEventHub,
        theme: theme.themeName,
        stopData: selectedStop.data,
        routesData,
        isDelayStop: isDelayStop(selectedStop.data),
        specialNeeds,
        terminalOffset: offset,
      };
    }

    let pickupStops = [],
      deliveryStops = [];
    selectedRoutes?.forEach((route) =>
      route.stops?.forEach((stop) => {
        if (stop.pickupId) {
          pickupStops = [...pickupStops, stop];
        } else {
          deliveryStops = [...deliveryStops, stop];
        }
      })
    );

    return (
      <div className={classes.routeMap}>
        <MapHeader
          label="Route Preview"
          isAutoZoomEnabled={isAutoZoomEnabled}
          toggleRouteAnimation={this.toggleRouteAnimation}
          userData={this.props.userData}
        />
        <Map
          zoom={appConstants.MAP_ZOOM_LEVEL}
          initialCenter={location}
          center={location}
          mapId="routeMap"
          mapTheme={theme.themeName}
          eventHub={glEventHub}
          mapConfig={this.props.configJSON?.maps}
          onClick={this.onMapClicked}
        >
          <DrawingTools
            rectangleOptions={{
              fillColor: theme.MapDrawingColor,
              strokeColor: theme.MapDrawingColor,
            }}
            polylineOptions={{
              strokeColor: theme.MapDrawingColor,
            }}
            polygonOptions={{
              fillColor: theme.MapDrawingColor,
              strokeColor: theme.MapDrawingColor,
            }}
            eventHub={Events}
          />
          <MapControls
            controlOptions={{
              zoomControl: {
                position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
              },
              satelliteViewControl: {
                position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
              },
              reCenterMapControl: {
                position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
              },
            }}
          />
          <Marker
            position={location}
            zIndex={2}
            forceUpdate
            isActiveShipment
            easeToAnimation
            mapZoomLevel={appConstants.MAP_ZOOM_LEVEL}
          >
            <TerminalMarker
              data={this.props.userData.userProfile.terminal}
              color={theme.terminalContentColor}
            />
          </Marker>

          {selectedRoutes?.map((route) => {
            const driverLocation = this.props.DispatchStore.getDriverLatLng(route.driverId)
            return (
              <>
                <Direction
                  origin={driverLocation ? null : location}
                  destination={getDispatchLastStop(route.stops)}
                  waypoints={getDispatchWayPoints(route.stops)}
                  strokeColor={route.color}
                  data={route}
                  key={route.routeId}
                  zIndex={0}
                  routeAnimation={Boolean(this.state.routeAnimation)}
                  enableRouteHover
                  driverLocation={driverLocation}
                />
                {driverLocation ? (
                  <Marker
                    position={driverLocation}
                    zIndex={1}
                    key={route.routeId}
                    data={route}
                  >
                    {getDispatchDriverMarker({
                      data: route,
                      isDelayed: isDriverDelayed(route),
                      theme,
                      color: route.color,
                    })}
                  </Marker>
                ) : null}
              </>
            );
            })}

          

          {deliveryStops.map((stop) => (
            <Marker
              data={{ ...stop }}
              position={{ lat: stop.latitude, lng: stop.longitude }}
              key={`${stop.stopId}_${stop.stopSequence}`}
              zIndex={stop.stopId === selectedStop?.data?.stopId ? 2 : 1}
              onClick={this.onRouteStopClicked}
            >
              {getDispatchRouteStopsMarker({
                stop,
                ...getStopMarkerColors({
                  theme,
                  stop,
                  routeColor: stop.color,
                }),
                isSelectedStop: Boolean(
                  selectedStop?.data?.stopId === stop.stopId
                ),
              })}
            </Marker>
          ))}

          <MapZoomChange thresholdZoomLevel={11}>
            {pickupStops?.map((stop) => (
              <Marker
                data={stop}
                position={{ lat: stop.latitude, lng: stop.longitude }}
                key={stop.stopId}
                zIndex={stop.stopId === selectedStop?.data?.stopId ? 2 : 1}
                onClick={this.onRouteStopClicked}
              >
                {stop.isVirtualStop
                  ? getVirtualStopMarker({
                      pickup: stop,
                      stopSequence: stop.stopSequence,
                      isSelectedStop: Boolean(
                        selectedStop?.data?.stopId === stop.stopId
                      ),
                      theme,
                      routeColor: stop.color,
                    })
                  : getDispatchRouteStopsMarker({
                      stop,
                      ...getStopMarkerColors({
                        theme,
                        stop,
                        routeColor: stop.color,
                      }),
                      isSelectedStop: Boolean(
                        selectedStop?.data?.stopId === stop.stopId
                      ),
                    })}
              </Marker>
            ))}

            {noFeasibleDriverPickups.length > 0 &&
              noFeasibleDriverPickups.map((pickup, i) => {
                const { isPickupActive, isPickupSelectedInGrid } =
                  this.getPickupActiveStatus(pickup);
                return (
                  <Marker
                    position={{
                      lat: pickup.shipperLatitude,
                      lng: pickup.shipperLongitude,
                    }}
                    onClick={this.onPickupMarkerClicked}
                    zIndex={isPickupActive ? 1 : 0}
                    key={pickup.pickupId}
                    isActiveShipment={isPickupSelectedInGrid}
                    data={pickup}
                  >
                    {getDispatchUnassignedPickupMarker(
                      getUnassignMarkerInfo({
                        pickup,
                        isPickupActive,
                        theme,
                        terminalOffset: DispatchStore.terminalOffset,
                      })
                    )}
                  </Marker>
                );
              })}
          </MapZoomChange>

          {selectedPickup && this.pickupSelectedOnMap && (
            <Popup
              position={selectedPickup.position}
              key={`${selectedPickup.data.pickupId}_pickupPopup`}
            >
              <DispatchUnassignedPickupPopupInfo
                theme={theme.themeName}
                hideAction
                specialNeeds={getSpecialNeeds(
                  DispatchStore.priorityAllShipmentList
                )}
                data={{ data: selectedPickup.data }}
                hideTerminalChange
                markerComponent={getMarkerComponent({
                  terminalOffset: offset,
                  pickup: selectedPickup,
                  theme,
                })}
              />
            </Popup>
          )}

          {isDeliveryStop && (
            <Popup marker={selectedStop.marker}>
              <DispatchStopDeliveryPopupInfo {...stopPopupCommonProps} />
            </Popup>
          )}

          {isPickupStop && (
            <Popup marker={selectedStop.marker}>
              <DispatchStopPickupPopupInfo
                hideAction
                pickupNumber={selectedStop.data.pickupNumber}
                {...stopPopupCommonProps}
              />
            </Popup>
          )}
        </Map>
      </div>
    );
  }
}

export default compose(withTheme(), withUserProfile, withAppConfig)(RouteMap);
